import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsernameIconComponent } from './username-icon.component';
import { FormsModule } from '@angular/forms';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [UsernameIconComponent],
  imports: [CommonModule, FormsModule, SvgIconModule, NgbTooltipModule],
  exports: [UsernameIconComponent],
})
export class UsernameIconModule {}
